import "./Header.css";
import logo from "../Assets/crucible_circle.png";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import { MdMenu, MdOutlineClose } from "react-icons/md";
import { useState } from "react";

const Header = ({ logOut, version }) => {
    const [navOpen, setNavOpen] = useState(false);

    const navigation = [
        { path: "/lw/", text: "LW" },
        { path: "/aris/", text: "ARIS" },
        { path: "/octopus/", text: "OCTOPUS" },
        { path: "/midas/", text: "MIDAS" },
        { path: "/links/", text: "LINKS" },
    ].map((item) => (
        <NavLink
            exact
            activeClassName="active-nav"
            to={item.path}
            key={item.text}
            onClick={() => {
                setNavOpen(false);
            }}
        >
            {item.text}
        </NavLink>
    ));

    navigation.push(
        <NavLink
            exact
            key="logout"
            to="/logout/"
            onClick={() => {
                setNavOpen(false);
                logOut();
            }}
        >
            LOGOUT
        </NavLink>,
    );

    return (
        <header>
            <NavLink
                className="logo-container"
                exact
                to="/"
                onClick={() => {
                    setNavOpen(false);
                }}
            >
                <img className="logo" src={logo} />
                <div style={{ position: "relative" }}>
                    <h1>FORGE</h1>
                    <p className="version-num">v{version}</p>
                </div>
            </NavLink>
            <nav id="desktop-nav">{navigation}</nav>
            {navOpen ? (
                <MdOutlineClose
                    onClick={() => {
                        setNavOpen(false);
                    }}
                    className="mobile-nav-btn"
                />
            ) : (
                <MdMenu
                    onClick={() => {
                        setNavOpen(true);
                    }}
                    className="mobile-nav-btn"
                />
            )}
            <nav className="mobile-nav" style={{ height: navOpen ? "100svh" : "6rem" }}>
                {navigation}
            </nav>
            <div className="header-backing"></div>
        </header>
    );
};

export default Header;
